import { useTranslations } from '@aikoa/i18n/react'
import { View } from 'react-native'
import { InterestDetailsView } from '~/components/interests/InterestDetailsView'
import ContentBox from '~/components/layout/ContentBox'
import { ViewTitle } from '~/components/layout/Sections'
import { ScrollView } from '~/components/ScrollView'
import { Body } from '~/components/typography/Content'
import { Heading1 } from '~/components/typography/Titles'
import { ButtonLabel, LinkButton } from '~/components/ui/button'
import { Link } from '~/components/ui/text'
import { useLatestRespondedFeedback } from '~/data/feedback/useFeedback'
import { useInterest } from '~/data/interests/useInterests'
import { cn } from '~/lib/utils'
import { PolicyLinks } from '../user/PolicyLinks'

export function BuyerHomeView() {
  const { t } = useTranslations(['home', 'common'])
  const { data: interest } = useInterest()
  const { data: latestFeedback } = useLatestRespondedFeedback()
  const supportEmail = t(($) => $.common.contactEmail)

  return (
    <ScrollView
      className={cn('flex-1 rounded-content transition-opacity duration-150')}
      offsetTrackHeight
      contentContainerClassName="relative gap-3 pt-3">
      <ContentBox
        variant="default"
        scrollable={false}
        contentContainerClassName="px-0 pt-8 empty:hidden"
        footerClassName="pb-6 pt-0">
        <ViewTitle className="mb-4">
          <Heading1 className="text-pretty text-center font-medium text-3xl/normal">
            {t(($) => $.buyer.heading)}
          </Heading1>
        </ViewTitle>
        <View className="gap-4 px-4">
          <Body className="text-pretty text-center text-lg/relaxed">
            {t(($) => $.buyer.description)}
          </Body>
          <LinkButton testID="buyer-home-edit-profile" variant="outline" href="/(authenticated)/profile">
            <ButtonLabel>{t(($) => $.buyer.editProfileButton)}</ButtonLabel>
          </LinkButton>
        </View>
        {!!interest && (
          <InterestDetailsView
            interest={interest.data}
            className="mt-6 rounded-xl bg-transparent"
            valueClassName="px-6"
          />
        )}
        {!!latestFeedback && (
          <LinkButton variant="primary" href="/(authenticated)/search/update">
            <ButtonLabel>{t(($) => $.buyer.updateSearchButton)}</ButtonLabel>
          </LinkButton>
        )}
        <View className="mt-4 px-6">
          <Body className="text-pretty text-center text-lg/relaxed">
            {t(($) => $.buyer.feedbackPrompt)}{' '}
            <Link className="font-semibold text-primary underline" href={`mailto:${supportEmail}`}>
              {supportEmail}
            </Link>
          </Body>
        </View>
      </ContentBox>
      <PolicyLinks />
    </ScrollView>
  )
}
